import fs from 'node:fs';
import path from 'node:path';
import { INDEX_DIR } from '../../files/index/constants.js';

/** Pre-SQLite CLI files are moved here (not deleted) for easier testing / rollback. */
export const OLD_VERSION_DIR = path.join(INDEX_DIR, 'old-version');

export type LegacyArchiveCategory = 'file-index' | 'agent-sessions' | 'queues';

export function moveLegacyFileToOldVersionBackup(category: LegacyArchiveCategory, sourcePath: string): void {
  const destDir = path.join(OLD_VERSION_DIR, category);
  fs.mkdirSync(destDir, { recursive: true });
  const base = path.basename(sourcePath);
  let dest = path.join(destDir, base);
  if (fs.existsSync(dest)) {
    const ext = path.extname(base);
    const stem = ext ? base.slice(0, -ext.length) : base;
    dest = path.join(destDir, `${stem}-${Date.now()}${ext}`);
  }
  fs.renameSync(sourcePath, dest);
}
